export default __webpack_public_path__ + "static/media/INEX front.67877821.png";